import { Alert, Box, Link, Stack, TextField, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';

import SERVER_API_URL from '../../../config';
import CustomButton from '../../../components/custom-button/CustomButton';

export default function GetVerificationCode() {
  const [disabled, setDisabled] = useState(false);
  const location = useLocation();
  const { email } = location.state;
  const [error, setError] = useState();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    const data = new FormData(e.currentTarget);
    if (data.get('code').length !== 8) {
      setError('እባክህ የሚሰራ ኮድ አስገቡ');
      setDisabled(false);
    }

    try {
      const jsonData = Object.fromEntries(data.entries());
      jsonData.email = email;
      const response = await axios.post(`${SERVER_API_URL}/auth/isValidCode`, jsonData);
      if (response.status === 202) {
        setError(null);
        localStorage.setItem('token', response.data.token);
        navigate('/setNewPassword', { state: { email: jsonData.email } });
      }
    } catch (e) {
      setError('የተሳሳተ ኮድ, እባክዎ እንደገና ይሞክሩ!');
      setDisabled(false);
    }
  };
  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          mx: 'auto',
        }}
      >
        <Stack spacing={2}>
          <Typography sx={{ pt: 2 }}>በዚህ ኢሜይል መለያ ካለ የማረጋገጫ ኮድ እንልካለን። ኢሜልዎን በመመልከት የማረጋገጫ ኮዱን ያስገቡ።</Typography>
          <Typography variant="subtitle2" color="info">
            ኮዱ እስኪ ገባ ትንሽ ጊዤ ሊወስድ ይችላል።
          </Typography>
        </Stack>
        <Stack spacing={3} sx={{ my: 2 }}>
          {error && (
            <Alert sx={{ width: '100%' }} severity="error">
              {error}
            </Alert>
          )}

          <TextField
            type="text"
            variant="outlined"
            id="code"
            name="code"
            label="Verification Code"
            autoFocus
            required
          />
        </Stack>

        <CustomButton fullWidth size="large" type="submit" variant="contained" disabled={disabled}>
          {!disabled && <>አስገባ</>}
          {disabled && (
            <>
              <CircularProgress style={{ width: '20px', height: '20px' }} />  አስገባ...
            </>
          )}
        </CustomButton>

        <Stack direction="row" justifyContent="right" sx={{ mt: 2 }}>
          <Link onClick={() => navigate('/login')} sx={{ cursor: 'pointer' }} variant="subtitle2" underline="hover">
            ተመለስ
          </Link>
        </Stack>
      </Box>
    </>
  );
}
